<div class="simple-repeat-container" [style]="containerStyles()" [class.grid]="props.gridView">
  @if (props.gridView) {
    <div class="simple-repeat-grid-header">
      @for (header of props.gridHeaders; track $index) {
        <div class="simple-repeat-grid-header-item">
          {{ header.label }}
        </div>
      }
    </div>
  }

  @for (field of field.fieldGroup; track field.id) {
    <div class="simple-repeat">
      <div class="simple-repeat-item">
        <formly-field [field]="field" />
      </div>

      @if (!props.readonly) {
        <div class="simple-repeat-actions">
          @if ($count > 1 || props.alwaysShowRemoveButton) {
            <cap-button
              class="remove"
              styleClass="default primary round btn-sm icon-only"
              icon="mynaui-trash"
              [tabIndex]="0"
              (keydown.enter)="remove($index)"
              (onClick)="remove($index)" />
          }
        </div>
      }
    </div>

    @if (showError && props.showInvalidFeedback) {
      <div class="field-invalid-feedback">
        <i class="mynaui-danger-triangle" aria-hidden="true"></i>

        <formly-validation-message id="{{ id }}-formly-validation-error" [field]="field" role="alert" />
      </div>
    }
  }
</div>

@if (!props.max || field.fieldGroup.length < props.max) {
  <div class="simple-repeat-buttons">
    <cap-button
      [tabIndex]="0"
      class="add"
      [class]="props.addButtonClass"
      styleClass="primary"
      icon="mynaui-plus"
      (keydown.enter)="add()"
      (onClick)="add()" />
  </div>
}
